module.exports = __webpack_public_path__ + "assets/icon_vpk.293ddd4e.svg";